import { ContentLayout } from "@2u-landing-pages/components";
import { Container } from "@red-digital/bricks";
import cn from "classnames";
import React from "react";

import { BentoProps, TileGroup } from "../../Bento.types";
import { Tiles } from "../../Tiles";
import styles from "./Inline.module.scss";

export const Inline: React.FC<BentoProps> = ({
  style,
  className,
  section_heading,
  items_group_one,
  items_group_two,
  items_group_three,
  embedded,
  variation,
}) => {
  const groups = [items_group_one, items_group_two, items_group_three].filter((val) => val) as TileGroup[];

  return (
    <Container className={cn({ [styles.asSection]: !embedded })} style={style}>
      <Container flex direction="column" lg={{ direction: "row" }} className={cn(styles.inline, className)}>
        {section_heading && (
          <ContentLayout
            className={styles.headingContainer}
            content={section_heading}
            heading={{
              className: styles.heading,
              variant: "heading-xl",
            }}
          />
        )}
        <Tiles variation={variation} embedded={embedded} groups={groups} />
      </Container>
    </Container>
  );
};
